<template>
    <Primitive
        :as="as"
        :class="classes"
        :style="style"
    >
        <slot />
    </Primitive>
</template>

<script setup lang="ts">
import type { KFrameProps } from './types'
import useBem from '@yeeroen/use-bem'
import { Primitive } from 'reka-ui'

import { computed } from 'vue'

defineOptions({ name: 'KFrame' })

const props = withDefaults(defineProps<KFrameProps>(), {
    as: 'div',
    ratio: 'auto',
    fit: 'cover',
    rounded: false,
    scrim: false,
})

defineSlots<{
    default?: () => unknown
}>()

const { block, modifier } = useBem('k-frame')

const classes = computed(() => block(
    modifier(`fit-${props.fit}`),
    modifier('rounded', props.rounded),
    modifier('scrim', props.scrim),
))

const style = computed(() => ({ '--frame-ratio': String(props.ratio) }))
</script>

<style lang="scss">
@use './k-frame.scss';
</style>
